export default "__VITE_ASSET__BwE_3SpP__"